import { IDestroyOptions, Point } from "pixi.js";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { WinCoinsAnimation } from "../../../common/components/animations/WinCoinsAnimation";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { ISmallWinCoinsController } from "../controllers/ISmallWinCoinsController";
import { DeadRollSmallCoinsAction } from "../../../game/flow/impl/diceActions/DeadRollSmallCoinsAction";
import { SoundsResourcePackageWrapper } from "../../../common/resources/SoundsResourcePackageWrapper";
import { TopPanel } from "../../../game/components/toppanel/TopPanel";
import { BaseScalableView } from "../../../common/BaseScalableView";

export class SmallWinCoinsPopupView extends BaseScalableView<void> {
    private readonly commonResources: CommonResourcesPackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly smallWinCoinsController: ISmallWinCoinsController;
    private readonly action: DeadRollSmallCoinsAction;
    private coinsCollectPoint: Point;
    private coinsCollectAnimation: WinCoinsAnimation;
    private topPanel: TopPanel;

    public constructor(
        operationControls: PromiseCompletionSource<void>,
        commonResources: CommonResourcesPackage,
        soundResources: SoundsResourcePackageWrapper,
        canvasScaler: ICanvasScaler,
        smallWinCoinsController: ISmallWinCoinsController,
        action: DeadRollSmallCoinsAction,
        topPanel: TopPanel
    ) {
        super(operationControls, canvasScaler);
        this.commonResources = commonResources;
        this.soundResources = soundResources;
        this.smallWinCoinsController = smallWinCoinsController;
        this.action = action;
        this.topPanel = topPanel;
        this.build();
        this.layout(this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
        this.once("added", this.show.bind(this));
    }

    public start(): void { }

    private build(): void {
        this.topPanel.bringToFront();
        this.coinsCollectPoint = new Point();
        this.coinsCollectAnimation = new WinCoinsAnimation(this.commonResources, this.commonResources.assets_common_ui_top_panel_coin_png, this.coinsCollectPoint, this.action.diceRollRewardInCoins);
        this.addChild(this.coinsCollectAnimation);
    }

    private async show(): Promise<void> {
        this.topPanel.show();
        this.smallWinCoinsController.collectCoins(this.action.diceRollRewardInCoins);
        this.soundResources.assets_sounds_Coins_Top_Bar_mp3.play();
        await this.coinsCollectAnimation.startAnimation();
        this.operationControls.complete();
    }

    private layout(width: number, height: number): void {
        this.coinsCollectPoint.set(0, (height * -0.45) + this.coinsCollectAnimation.height);
        this.coinsCollectAnimation.position.set(width * 0.45, height * 0.5);
    }

    public destroy(options?: boolean | IDestroyOptions): void {
        this.topPanel.bringToOriginParent();
        super.destroy(options);
    }
}